import { gql } from '@apollo/client';

const MORPHOLOGY_OVERVIEW = gql`
  query morphologyOverview($input: MorphologyOverviewInput!) {
    morphologyOverview(input: $input) {
      isSuccess
      message
      morphologyOverview {
        id
        centerVector
        total
        reviewed
        isIncludedToReport
        unclassified
        rrHeatMapCells {
          id
          total
          reviewed
        }
      }
    }
  }
`;

export default MORPHOLOGY_OVERVIEW;
